module.exports = __webpack_public_path__ + "media/views/about/images/icons/faq_7-4bccecae4907b6d02e8c5e329866e1f9.svg";